import { AboutHero } from "@/components/about/AboutHero";
import { AboutMission } from "@/components/about/AboutMission";
import { AboutFeatures } from "@/components/about/AboutFeatures";
import { AboutContact } from "@/components/about/AboutContact";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const AboutUs = () => {
  const breadcrumbItems = [
    { label: "About Us" }
  ];

  return (
    <div className="min-h-screen">
      <AboutHero />
      <div className="container mx-auto px-4 py-12">
        <Breadcrumbs items={breadcrumbItems} />
        <div className="max-w-4xl mx-auto space-y-16">
          <AboutMission />
          <AboutFeatures />
          <AboutContact />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;